/**
 * eventsApi (web) — best-effort telemetry to POST /events/v1/ingest
 * (functions-py -> client_events). Fire-and-forget; never throws.
 * X-App-Version is attached by the shared http client.
 */
import { httpClient } from '../http';

export interface AnalyticsEvent {
  type: string;
  payload?: Record<string, unknown>;
  timestamp?: string;
}

export async function trackEvents(
  events: AnalyticsEvent[],
  opts?: { sourceId?: string; trackingSessionId?: string },
): Promise<void> {
  if (!events.length) return;
  const stamped = events.map(e => ({
    ...e,
    timestamp: e.timestamp ?? new Date().toISOString(),
  }));
  try {
    await httpClient.post('/events/v1/ingest', {
      source: 'webapp',
      source_id: opts?.sourceId,
      tracking_session_id: opts?.trackingSessionId,
      events: stamped,
    });
  } catch {
    // analytics is best-effort
  }
}

/** Fire-and-forget tap on a Discover/Book category chip. */
export function trackDiscoverCategoryTap(args: {
  key: string;
  label?: string;
  position: number;
  source?: 'grid' | 'featured' | 'chip';
  destination?: string | null;
}): void {
  void trackEvents([
    {
      type: 'discover_category_tap',
      payload: {
        key: args.key,
        label: args.label,
        position: args.position,
        source: args.source ?? 'chip',
        destination: args.destination ?? null,
      },
    },
  ]);
}
